module.exports = __webpack_public_path__ + "media/images/pc/page_common/purpose_photo-4df0aac9c57d20f210bbc54bfaaeca8d.png";